'use client';

const BASE_CLASSES =
  'fixed top-0 z-[999] p-[10px] text-xl font-bold shadow-[0_0_5px_rgba(0,0,0,0.3)]';

export interface CallcenterBannerProps {
  /** Token role: 1 = callcenter agent ready, other values are not callcenter */
  role?: number;
  /** Token type: 6 = callcenter agent active on customer session */
  type?: number;
  /** System name from token (e.g. "vtpipe", "fit"), undefined in production */
  systemName?: string;
}

/**
 * Renders fixed-position banners for callcenter agents and non-production systems.
 * Replaces the direct DOM manipulation previously done by the mybuy-session package.
 */
export const CallcenterBanner = ({ role, type, systemName }: CallcenterBannerProps) => {
  const isCallcenterReady = role === 1;
  const isCallcenterActive = type === 6;
  const showCallcenter = isCallcenterReady || isCallcenterActive;

  return (
    <>
      {showCallcenter && (
        <div
          className={`${BASE_CLASSES} left-0 ${isCallcenterActive ? 'bg-[rgba(255,255,100,0.7)]' : 'bg-[rgba(100,255,100,0.7)]'}`}
        >
          {isCallcenterActive ? 'Callcenter - aktiv' : 'Callcenter - bereit'}
        </div>
      )}
      {systemName && (
        <div className={`${BASE_CLASSES} left-[47%] bg-[rgba(255,128,128,0.7)]`}>
          System: {systemName}
        </div>
      )}
    </>
  );
};
